/**
 * Купон Polymarket на телефоне. Стол не трогаем: couponUrl как был.
 *
 * Виджет на сайте ест query (marketSlug, outcomeIndex, shares, price).
 * Приложение и новые ссылки — путь `/event/{событие}/{рынок}` (ts-sdk,
 * скопированный URL с сайта). Кладём оба: путь для приложения, query для Safari.
 * «сайт, не приложение» — оставляем стол (только /event/{событие}?marketSlug=).
 */

import { polyEventSlug } from '../../poly/coupon';

export function isPolyHttp(url: string): boolean {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return host === 'polymarket.com' || host.endsWith('.polymarket.com');
  } catch {
    return false;
  }
}

export function polyCouponPhone(desk: string, opts?: { webOnly?: boolean }): string {
  if (opts?.webOnly) return desk;
  if (!isPolyHttp(desk)) return desk;
  try {
    const page = new URL(desk);
    const event = polyEventSlug(desk);
    const market = page.searchParams.get('marketSlug');
    if (event === null || market === null || market === '' || market.includes('/')) return desk;
    page.pathname = `/event/${event}/${market}`;
    return page.toString();
  } catch {
    return desk;
  }
}
